import React from 'react';
import { Banner } from '../Banner';
import { Promotions } from '../Promotions';
import { TopCasinoGames } from '../TopCasinoGames';
import { FAQ } from '../FAQ';
import { MobileApps } from '../MobileApps';
import { useHomepageStyles } from '../../../hooks/use-homepage-styles.hook';
import { OffersDataService } from '../../../services/offers-data.service';
import { VerticalSEOStrip } from '../../../../verticals/src/contaiters/VerticalSEOStrip';
import { BlockSeparator } from '../BlockSeparator';

export const Homepage = ({ changedVerticalOnClick }) => {
    const {
        isShownFaqSection,
        isShownGamesSection,
        isShownMobileAppSection,
        isShownPromotionsSection,
        mainBannerLayout
    } = OffersDataService.getOffersData();

    const isBannerSeparatorAvailable =
        isShownPromotionsSection ||isShownFaqSection || isShownGamesSection || isShownMobileAppSection;
    const isPromotionSeparatorAvailable = isShownFaqSection || isShownGamesSection || isShownMobileAppSection;
    const isGamesSeparatorAvailable = isShownFaqSection || isShownMobileAppSection;

    useHomepageStyles();

    return (
        <div className="homepage-page-container">
            <Banner />
            {(mainBannerLayout !== 'center' && isBannerSeparatorAvailable) &&
                <BlockSeparator className="banner-separator" />}

            {isShownPromotionsSection &&
                <>
                    <Promotions />
                    {isPromotionSeparatorAvailable && <BlockSeparator />}
                </>}

            {isShownGamesSection &&
                <>
                    <TopCasinoGames />
                    {isGamesSeparatorAvailable && <BlockSeparator />}
                </>}

            {isShownFaqSection && <FAQ />}

            {isShownMobileAppSection && <MobileApps />}

            <VerticalSEOStrip changedVerticalOnClick={changedVerticalOnClick} />
        </div>
    );
};
